import React, { useState, useEffect } from "react";
import {FiCheck} from 'react-icons/fi';
import Main from "../../components/template/Main";
import { useHistory,useParams } from "react-router-dom";
import {get} from '../../store/config/register';
import { parse,format } from "date-fns";
import { login_Id } from "../../store/config/dadosuser";
import './HorariosAgendamento.css';
import useTable from "../../components/table/useTable";
import TableFooter from "../../components/table/TableFooter";
import ModalAgenda from "../Modal/ModalAgenda";

const headerProps = {
    icon: "calendar-plus-o",
    title: "Horário de Agendamento",
  }

export default function HorariosAgendamentos() {

    const [horarios, setHorarios] = useState([]);
    const [agendamentos,setAgendamentos] = useState([]);
    const [espaco, setEspaco] = useState({});
    const [usuario,setUsuario] = useState({});
    const {data,id}=useParams();
    const history = useHistory();
    const [page, setPage] = useState(1);
    const { slice, range } = useTable(horarios, page, 6);
    const [item,setItem]=useState({});
    const [modalState, setModalState] = useState(false);

    const dia =parse(data,'dd-MM-yyyy',new Date());

    useEffect(()=>{
        buscaEspaco();
        VerificaUsuario();
        buscaAgenda();
        Horarios(dia.getDay()+1);
    },[])

    async function buscaEspaco() {
        const esp = await get('/Espaco/v1/'+ id);
       
         if(esp !== undefined){
           setEspaco(esp)
         }
       }

       async function buscaAgenda() {
        const agenda = await get(`/EspacoAgenda/v1/Dia?espaco_id=${id}&inicio=${format(dia,'yyyy-MM-dd')}`);
         if(agenda !== undefined){
            setAgendamentos(agenda)
         }
       }
       //

       async function VerificaUsuario(){

        if(login_Id > 0){
          const  result = await  get(`/Login/v1/${login_Id}`);
          setUsuario(result)
       }
       
      }

      function togglePostModal(item){
       
        item.espaco_id = id;
        item.espaco_nome = espaco.nome;
        item.termo = espaco.termo;
        item.usuario = usuario;
        item.login_id = login_Id;
        item.padrao =[{hora_Inicio: item.hora_Inicio}]
        item.data =dia
       
        setItem({...item})   
      setModalState(!modalState) //trocando de true pra false
  }

    async function Horarios(diaSemana) {

       const hors= await get(`/EspacoPeriodoHora/v1/Horarios?espaco_id=${id}&dia_semana=${diaSemana}`)
        if(hors.length > 0){
               setHorarios(hors)
           }
       }

    function renderForm() {
        return (
            <div className="horario">
           <div className="box">
           <div className="box2">
           <label>Local:</label>
           </div>
           <div className="box3">
           <label>{espaco.nome}</label>
           </div>
   
           </div>
           <div className="box">
           <div className="box2">
           <label>Data:</label>
           </div>
           <div className="box3">
           <label>{format(dia,'dd/MM/yyyy')}</label>
           </div>
            </div>

            <div className="box">
           <div className="box2">
           <label>Unid:</label>
           </div>
           <div className="box3">
           <label>{usuario.unidade +' - '+ usuario.bloco }</label>
           </div>
            </div>
              
                <hr/>

                {modalState && (
                <ModalAgenda 
                conteudo={item} 
                close={togglePostModal} />)}
                <table>
                <thead>
                    <tr>
                        <th scope="col">Horário</th>
                    </tr>
                </thead>
                {  slice.length === 0 ? null : slice.map((item,index) => {
                    let agenda =agendamentos.filter(f => f.hora_Inicio === item.hora_Inicio.toString().substring(0,5));
                                return( 
                                    <tbody>
                                        <tr key={index}>
                                            <td data-label="Horário">{item.hora_Inicio.toString().substring(0,5)}</td>
                                            <td  data-label="">
                                            {agenda.length === 0 ? (
                                                 <button className="action" style={{backgroundColor: '#008000' ,marginRight: "20px" }} data-toggle="tooltip" data-placement="bottom" title="Editar" onClick={(e) => togglePostModal(item)} >
                                                 <FiCheck color="#FFF" size={17} />
                                                 </button>
                                            ): 
                                            (
                                                <button className="action" style={{backgroundColor: '#d3d3d3' ,marginRight: "20px" }} data-toggle="tooltip" data-placement="bottom" >
                                                <FiCheck color="#FFF" size={17} />
                                                </button>
                                            )}
                                                
                                            </td>
                                        </tr>
                                    </tbody>
                                );
                                })}
                </table>
                <TableFooter range={range} slice={slice} setPage={setPage} page={page} />
            </div>
        );
    }

    return (
        <Main {...headerProps}>
            {renderForm()}
        </Main>
    );
}